import { useTranslation } from "react-i18next";
import { Checkbox } from "@tellescope/ui";
import { formatCurrency } from "@tellescope/utils";
import { formatIntervalSuffix } from "../enduser/formatShopPrice";
import type { StripeShopPrice } from "./stripeShopTypes";

interface PriceVariantRowProps {
  price: StripeShopPrice;
  selected: boolean;
  onToggle: () => void;
}

export const PriceVariantRow = ({ price, selected, onToggle }: PriceVariantRowProps) => {
  const { t } = useTranslation("shop");
  const amountLabel =
    price.unit_amount === null
      ? t("Custom pricing")
      : `${formatCurrency(price.unit_amount, price.currency, { fromSmallestUnit: true })}${
          price.recurring ? formatIntervalSuffix(t, price.recurring.interval, price.recurring.interval_count) : ""
        }`;

  return (
    <label
      role="button"
      onClick={onToggle}
      className="flex gap-3 items-center rounded-md p-2 pl-8 hover:bg-muted cursor-pointer"
    >
      <Checkbox checked={selected} onCheckedChange={onToggle} onClick={(e) => e.stopPropagation()} />
      <span className="text-sm flex-1">{amountLabel}</span>
      <span className="text-xs text-muted-foreground">
        {price.type === "recurring" ? t("Subscription") : t("One-time")}
      </span>
    </label>
  );
};
